import { http, HttpResponse } from 'msw'

import { allSaleReports } from 'app/mocks/data/reports/sale'

import {
    api,
    isNumeric,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

import { SaleReportsRequest } from 'app/types/reports/sale'

export const getAllSaleReports = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.reports.sale.ALL}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allSaleReports.length > limit
                ? offset + limit
                : allSaleReports.length

        const results = allSaleReports.slice(offset, limitArray)

        const next =
            offset + results.length < allSaleReports.length
                ? 'again'
                : undefined

        return HttpResponse.json<SaleReportsRequest>({
            next,
            results,
        })
    },
)
